import {memo} from 'react';
import useScriptLoad from '~/hooks/useScriptLoad';
import {ELEMENT_IDS} from '~/lib/const';

const scriptConfigs = [
  {
    id: ELEMENT_IDS.GORGIAS_CHAT_BUNDLE_LOADER,
    url: 'https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=17446',
  },
  {
    id: ELEMENT_IDS.GORGIAS_CHAT_BUNDLE,
    url: 'https://config.gorgias.chat/gorgias-chat-bundle.js?applicationId=17446&rev=014b51fc&amp',
  },
];

const ChatWidget = memo(() => {
  useScriptLoad(scriptConfigs);

  return (
    <>
      <div id={'gorgias-chat-container'} />
    </>
  );
});

export default ChatWidget;
